/**
 * Generate a specific id to store a comment id in drag n drop
 */
export function commentIdDnd(commentId: string) {
  return "comment-" + commentId;
}

/**
 * Extract comment id from drag n drop store
 */
export function extractCommentIdDnd(data: any) {
  const split = data.split("comment-");
  if (split.length === 0) {
    return null;
  }
  return split.length === 0 ? null : split[1];
}



// WEBPACK FOOTER //
// ./src/helpers/dragndrop.ts